import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Table,
} from "@mui/material";
import React, { useState } from "react";
import Chart from "react-apexcharts";
import Card2 from "../../core/layouts/Card2";
import Card1 from "../../core/layouts/Card1";

const pallete = "palette10";
const cardHeight = "108px";
const cardFontSize = "25px";

export default function PlacementDashboard() {
  const pieChart = {
    series: [13, 40, 10, 30],

    options: {
      theme: {
        palette: pallete, // Options: 'palette1' to 'palette10'
      },
      colors: [
        "rgba(226, 130, 5, 0.77)",
        "rgba(161, 79, 179, 0.8)",
        "rgba(39, 36, 189, 0.77)",
        "rgba(64, 146, 184, 0.77)",
      ],
      chart: {
        type: "donut",
      },
      stroke: {
        show: false,
      },
      legend: {
        show: true,
        position: "right",
        layout: "horizental",
      },
      dataLabels: {
        enabled: false,
      },
      labels: ["IBM", "TCS", "Microsoft", "Google"],
    },
  };

  const boxPlot = {
    series: [
      {
        data: [
          {
            x: "2021",
            y: [40, 51.98, 56.29, 59.59, 63.85],
          },
          {
            x: "2022",
            y: [43.66, 44.99, 51.35, 52.95, 59.42],
          },
          {
            x: "2023",
            y: [40, 51.98, 56.29, 59.59, 63.85],
          },
          {
            x: "2024",
            y: [40, 51.98, 56.29, 59.59, 63.85],
          },
          {
            x: "2025",
            y: [52.76, 57.35, 59.15, 63.03, 67.98],
          },
        ],
      },
    ],
    options: {
      chart: {
        type: "boxPlot",
        toolbar: {
          show: false,
        },
      },
      title: { text: "", show: false },
      plotOptions: {
        boxPlot: {
          colors: {
            upper: "rgba(161, 79, 179, 0.8)",
            lower: "rgba(204, 91, 161, 0.8)",
          },
        },
        bar: {
          columnWidth: "40%",
        },
      },
      xaxis: {
        type: "category",
        title: {
          text: "Year",
        },
      },
      yaxis: {
        title: {
          text: "CTC",
        },
      },
    },
  };

  const organizationType = {
    series: [
      {
        data: [1404, 1193, 876, 208],
      },
    ],
    options: {
      theme: {
        palette: pallete, // Options: 'palette1' to 'palette10'
      },
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      colors: ["rgba(161, 79, 179, 0.8)"],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: +75,
        style: {
          colors: ["#000"],
        },
      },
      xaxis: {
        categories: ["Dream", "Bulk", "Super Dream", "Not Placed"],
      },
      yaxis: {
        title: {
          text: "No. of students",
        },
      },
      legend: {
        position: "top",
      },
    },
  };

  const numOffers = {
    series: [
      {
        data: [1282, 2212, 200],
      },
    ],
    options: {
      theme: {
        palette: pallete, // Options: 'palette1' to 'palette10'
      },
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      colors: ["rgba(161, 79, 179, 0.8)"],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: +60,
        style: {
          colors: ["#000"],
        },
      },
      xaxis: {
        categories: ["1", "2+", "0"],
      },
      yaxis: {
        title: {
          text: "No. of students",
        },
      },
      legend: {
        position: "top",
      },
    },
  };

  const [subject, setSubject] = useState("Overall");

  return (
    <Box style={{ width: "100%" }}>
      <Grid container>
        <Grid item xs={5}>
          <h3>Placement Dashboard - 2024-2025</h3>
        </Grid>
        <Grid item xs={7} style={{ textAlign: "right" }}>
          <FormControl component="fieldset" style={{ marginTop: 22 }}>
            <RadioGroup
              row
              aria-label="options"
              name="options"
              value={subject}
              onChange={(e) => {
                setSubject(e.target.value);
              }}
            >
              {[
                "Overall",
                "MBA (Day)",
                "MBA (HRM)",
                "MBA (Public System)",
                "MSW",
              ].map((option, index) => (
                <FormControlLabel
                  key={option}
                  value={option}
                  control={
                    <Radio
                      sx={{
                        p: 0.5,
                        "& .MuiSvgIcon-root": { fontSize: 12 },
                      }}
                    />
                  } // smaller radio
                  label={option}
                  sx={{ fontSize: "0.2rem", mx: 1 }} // smaller label text
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container columnSpacing={1}>
        <Grid item xs={4}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Card2
                title="Total Students"
                style={{ height: cardHeight, paddingTop: "10%" }}
              >
                <h2 style={{ marginTop: "5px", fontSize: cardFontSize }}>
                  101
                </h2>
              </Card2>
            </Grid>
            <Grid item xs={6}>
              <Card2
                title="Eligible Students"
                style={{ height: cardHeight, paddingTop: "10%" }}
              >
                <h2 style={{ marginTop: "5px", fontSize: cardFontSize }}>83</h2>
              </Card2>
            </Grid>
            <Grid item xs={6}>
              <Card2
                title="Student Placed"
                style={{ height: cardHeight, paddingTop: "10%" }}
              >
                <h2 style={{ marginTop: "5px", fontSize: cardFontSize }}>62</h2>
              </Card2>
            </Grid>
            <Grid item xs={6}>
              <Card2
                title="Percentage Placed"
                style={{ height: cardHeight, paddingTop: "10%" }}
              >
                <h2 style={{ marginTop: "5px", fontSize: cardFontSize }}>
                  61%
                </h2>
              </Card2>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={8}>
          <Card1 title="CTC performance by year">
            <Chart
              options={boxPlot.options}
              series={boxPlot.series}
              type="boxPlot"
              height={142}
            />
          </Card1>
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: "8px" }} columnSpacing={1}>
        <Grid item xs={4}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Card2
                title="Total recruiters"
                style={{ height: cardHeight, paddingTop: "10%" }}
              >
                <h2 style={{ marginTop: "5px", fontSize: cardFontSize }}>38</h2>
              </Card2>
            </Grid>
            <Grid item xs={6}>
              <Card2
                title="First time recruiters"
                style={{
                  height: cardHeight,
                  paddingTop: "10%",
                  fontSize: cardFontSize,
                }}
              >
                <h2 style={{ marginTop: "5px", fontSize: cardFontSize }}>
                  10%
                </h2>
              </Card2>
            </Grid>
            <Grid item xs={6}>
              <Card2
                title="Highest CTC"
                style={{ height: cardHeight, paddingTop: "10%" }}
              >
                <h2 style={{ marginTop: "5px", fontSize: cardFontSize }}>
                  25L
                </h2>
              </Card2>
            </Grid>
            <Grid item xs={6}>
              <Card2
                title="Offered By"
                style={{ height: cardHeight, paddingTop: "10%" }}
              >
                <h2 style={{ marginTop: "5px", fontSize: cardFontSize }}>
                  Google
                </h2>
              </Card2>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Card1 title="Intake by companies">
            <Chart
              options={pieChart.options}
              series={pieChart.series}
              type="donut"
              width="288"
            />
          </Card1>
        </Grid>
        <Grid item xs={4}>
          <Card1 title="Student offers">
            <Chart
              options={numOffers.options}
              series={numOffers.series}
              type="bar"
              height={155}
            />
          </Card1>
        </Grid>
      </Grid>
    </Box>
  );
}
